<template>
        <div ref="markerName" style="border-radius: 2px;background: rgba(255, 255, 255, 0.7); justify-content: center;align-items: center;display: flex;padding: 0 3px;font-size: 14px">
            {{markerNameInfo.properties.name}}
        </div>
</template>

<script>
    import mapboxgl from "mapbox-gl";
    export default {
        name: "MarkerName",
        props:["markerNameInfo"],
        data() {
            return {
                marker: ''
            }
        },
        mounted() {
            this.marker = new mapboxgl.Marker(this.$refs.markerName)
                .setLngLat([this.markerNameInfo.geometry.coordinates[0], this.markerNameInfo.geometry.coordinates[1]])
                .setOffset([0,-20])
                .addTo(this.$parent.$parent.map)
            // this.marker = new mapboxgl.Marker(this.$refs.markerName)
            //     .setLngLat([this.markerNameInfo.geometry.coordinates[0], this.markerNameInfo.geometry.coordinates[1]])
            //     .addTo(this.$parent.$parent.map)
        },
        destroyed() {
            this.marker.remove()
        },
        render() {
            return null;
        },
    }
</script>

<style scoped>

</style>
